
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Filter } from "lucide-react";

interface PrintableCategory {
  id: string;
  name: string;
}

interface CategoryFilterProps {
  categories: PrintableCategory[];
  selectedCategory: string;
  onCategoryChange: (value: string) => void;
  getCategoryName: (categoryId: string | null) => string;
}

const CategoryFilter = ({ 
  categories, 
  selectedCategory, 
  onCategoryChange, 
  getCategoryName 
}: CategoryFilterProps) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Filter className="w-5 h-5" />
          Filter by Category
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="w-64">
          <Select value={selectedCategory} onValueChange={onCategoryChange}>
            <SelectTrigger>
              <SelectValue placeholder="Select a category to filter" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="all">All Categories</SelectItem>
              {categories.map((category) => (
                <SelectItem key={category.id} value={category.id}>
                  {category.name}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      </CardContent>
    </Card>
  );
};

export default CategoryFilter;
